import React from 'react'
import PropTypes from 'prop-types'

const ListeCalendar = ({ children, titre }) => {
    return (
        <div className="flex flex-col gap-4 p-6 my-6 bg-[#272727] rounded-lg shadow-lg w-full">
            <h2 className="text-white font-semibold text-xl font-poppins">{titre}</h2>
            
            <div className="flex flex-col gap-8">
                {children}
            </div>
        </div>
    )
}

ListeCalendar.propTypes = {
    children: PropTypes.node,
    titre: PropTypes.string,
}

ListeCalendar.defaultProps = {
    children: null,
    titre: 'Calendrier',
};

export default ListeCalendar;

